var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5936 5.45838C9.93293 5.77824 10.4831 5.77824 10.8224 5.45838C11.1617 5.13861 11.1617 4.62016 10.8224 4.3003L6.76844 0.479666C6.08983 -0.159891 4.98945 -0.159891 4.31084 0.479666L0.254462 4.30268C-0.0848439 4.62245 -0.084844 5.14098 0.254462 5.46076C0.593768 5.78054 1.14396 5.78054 1.48326 5.46076L4.66865 2.45861L4.66865 17.1811C4.66865 17.6334 5.05766 18 5.53755 18C6.01745 18 6.40646 17.6334 6.40646 17.1811L6.40646 2.45476L9.5936 5.45838Z",
    fill: "#1B224C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.1938ae70f8bb417fafc5cde2ed77578d.svg";
export { ForwardRef as ReactComponent };